export const FETCH_SHOPS_FOR_FILTER = 'FETCH_SHOPS_FOR_FILTER';
export const UPDATE_SHOP_FILTER = 'UPDATE_SHOP_FILTER';
export const SHOP_FILTER_SELECT_ALL = 'SHOP_FILTER_SELECT_ALL';
export const SHOP_FILTER_DESELECT_ALL = 'SHOP_FILTER_DESELECT_ALL';
